<template>
  <div class="flex flex-col py-4">
    <vs-col
      vs-w="12"
      vs-type="flex"
      vs-align="center"
      vs-justify="space-between"
    >
      <div class="flex">
        <feather-icon
          class="mr-4"
          icon="FileTextIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        />
        <h4>Currículo</h4>
      </div>

      <vs-button
        class="mobile-hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-curriculumn' })"
      >
        Editar
      </vs-button>

      <vs-button
        class="sm:hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-curriculumn' })"
      />
    </vs-col>

    <hr class="my-4 line" />

    <div class="curriculo__wrapper" v-if="show()">
      <vs-button
        type="flat"
        color="primary"
        @click="handleVisualizeCurriculumn"
      >
        Visualizar Currículo
      </vs-button>
    </div>
    <EmptyDetailCard
      v-else
      description="Você ainda não enviou o seu currículo..."
    />
  </div>
</template>

<script>
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";
import { mapState } from "vuex";

export default {
  computed: { ...mapState("basicInfo", ["basicInfo"]) },

  methods: {
    show() {
      return (
        this.basicInfo.curriculum_url !== "" &&
        this.basicInfo.curriculum_url !== null
      );
    },
    handleVisualizeCurriculumn() {
      window.open(`${this.basicInfo.curriculum_url}`, "_blank");
    }
  },
  components: { EmptyDetailCard }
};
</script>

<style lang="scss">
.curriculo__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}
</style>
